<!-- src/app/pages/volunteer/volunteer.component.html -->

<section class="volunteer-page">
  <div class="container">

    <!-- PAGE HERO -->
    <header class="volunteer-hero">
      <h1>Volunteer with Lydia</h1>

      <p>
        Join <span>Michigan's Unchained Voice</span> and help build the
        grassroots campaign across Michigan.
      </p>
    </header>


    <!-- CONSTITUTIONAL CAPTAINS BANNER -->
<div class="captains-banner">

  <div class="captains-banner__image">
    <picture>
      <source srcset="assets/bannerFinalizedNoStars.webp" type="image/webp">
      <img
        class="captains-banner__img"
        src="assets/bannerFinalizedNoStars.png"
        alt="Lydia Christensen for U.S. Senate - Unchain Michigan"
        loading="lazy"
      />
    </picture>
  </div>

  <div class="captains-banner__badge">
    ★ Constitutional Captains Program ★
  </div>

  <h2 class="captains-banner__title">
    Help Lydia Win Michigan
  </h2>

  <p class="captains-banner__body">
    As the Libertarian Party nominee, Lydia is automatically on the ballot -
    now it's about turnout. We need <strong>15,000 doors knocked</strong>
    across Michigan by <strong>Election Day, November 3, 2026</strong>.
    Become a Constitutional Captain and canvass your community.
  </p>

</div>


    <!-- GOTV TRACKER -->
    <section class="volunteer-section tracker-section-wrap">

      <div class="section-heading">
        <h2>GOTV Drive Progress</h2>

        <p>
          Track our statewide canvassing effort and see where volunteers
          are active across Michigan.
        </p>
      </div>

      <app-sig-tracker></app-sig-tracker>

    </section>


    <!-- COUNTY MAP -->
    <section class="volunteer-section map-section-wrap">

      <div class="section-heading">
        <h2>Michigan County Captain Map</h2>

        <p>
          See where Constitutional Captains are already working and
          which counties still need leaders.
        </p>
      </div>

      <app-mi-map></app-mi-map>

    </section>


    <!-- PACKET REQUEST -->
    <section class="volunteer-section form-section" id="request-forms">

      <div class="section-heading">
        <h2>Knock Doors in Your Community</h2>

        <p>
          Can't print at home? We'll mail you canvassing packets so you
          can start knocking doors right away.
        </p>
      </div>

      <form
        #petitionForm="ngForm"
        (ngSubmit)="onPetitionRequest(petitionForm)"
        *ngIf="!petitionSubmitted"
        id="petition-form"
      >

        <div class="form-grid">

          <!-- NAME -->
          <div class="form-group">
            <label for="pet-name">Full Name</label>

            <input
              id="pet-name"
              type="text"
              placeholder="Full Name"
              required
              [(ngModel)]="petition.name"
              name="petName"
              #petName="ngModel"
              [disabled]="isPetitionSubmitting"
            />

            <div
              *ngIf="petName.invalid && petName.touched"
              class="error"
            >
              Full name is required.
            </div>
          </div>


          <!-- EMAIL -->
          <div class="form-group">
            <label for="pet-email">Email Address</label>

            <input
              id="pet-email"
              type="email"
              placeholder="Email Address"
              required
              [(ngModel)]="petition.email"
              name="petEmail"
              #petEmail="ngModel"
              pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
              [disabled]="isPetitionSubmitting"
            />

            <div
              *ngIf="petEmail.invalid && petEmail.touched"
              class="error"
            >
              <span *ngIf="petEmail.errors?.['required']">
                Email is required.
              </span>

              <span *ngIf="petEmail.errors?.['pattern']">
                Please enter a valid email address.
              </span>
            </div>
          </div>


          <!-- PHONE -->
          <div class="form-group">
            <label for="pet-phone">
              Phone Number
              <span class="optional">(optional)</span>
            </label>

            <input
              id="pet-phone"
              type="tel"
              placeholder="Phone Number (optional)"
              [(ngModel)]="petition.phone"
              name="petPhone"
              [disabled]="isPetitionSubmitting"
            />
          </div>


          <!-- ADDRESS -->
          <div class="form-group form-group--wide">
            <label for="pet-address">Mailing Address</label>

            <input
              id="pet-address"
              type="text"
              placeholder="Street Address"
              required
              [(ngModel)]="petition.address"
              name="petAddress"
              #petAddress="ngModel"
              [disabled]="isPetitionSubmitting"
            />

            <div
              *ngIf="petAddress.invalid && petAddress.touched"
              class="error"
            >
              Mailing address is required.
            </div>
          </div>


          <!-- CITY -->
          <div class="form-group">
            <label for="pet-city">City</label>

            <input
              id="pet-city"
              type="text"
              placeholder="City"
              required
              [(ngModel)]="petition.city"
              name="petCity"
              #petCity="ngModel"
              [disabled]="isPetitionSubmitting"
            />

            <div
              *ngIf="petCity.invalid && petCity.touched"
              class="error"
            >
              City is required.
            </div>
          </div>


          <!-- ZIP -->
          <div class="form-group">
            <label for="pet-zip">Zip Code</label>

            <input
              id="pet-zip"
              type="text"
              placeholder="Zip Code"
              required
              [(ngModel)]="petition.zip"
              name="petZip"
              #petZip="ngModel"
              pattern="\d{5}"
              [disabled]="isPetitionSubmitting"
            />

            <div
              *ngIf="petZip.invalid && petZip.touched"
              class="error"
            >
              <span *ngIf="petZip.errors?.['required']">
                Zip code is required.
              </span>

              <span *ngIf="petZip.errors?.['pattern']">
                Zip code must be 5 digits.
              </span>
            </div>
          </div>


          <!-- COUNTY -->
          <div class="form-group">
            <label for="pet-county">Michigan County</label>

            <select
              id="pet-county"
              required
              [(ngModel)]="petition.county"
              name="petCounty"
              #petCounty="ngModel"
              [disabled]="isPetitionSubmitting"
            >
              <option value="">Select Your County</option>

              <option
                *ngFor="let county of michiganCounties"
                [value]="county"
              >
                {{ county }}
              </option>
            </select>

            <div
              *ngIf="petCounty.invalid && petCounty.touched"
              class="error"
            >
              Please select your county.
            </div>
          </div>


          <!-- QUANTITY -->
          <div class="form-group">
            <label for="pet-quantity">
              Canvassing Packets
            </label>

            <select
              id="pet-quantity"
              required
              [(ngModel)]="petition.quantity"
              name="petQuantity"
              [disabled]="isPetitionSubmitting"
            >
              <option value="5">5 packets (~50 doors)</option>
              <option value="10">10 packets (~100 doors)</option>
              <option value="25">25 packets (~250 doors)</option>
              <option value="50">50 packets (~500 doors)</option>
            </select>
          </div>

        </div>


        <button
          type="submit"
          class="form-button"
          [disabled]="petitionForm.invalid || isPetitionSubmitting"
          aria-label="Request canvassing packets by mail"
        >
          {{
            isPetitionSubmitting
              ? 'Sending...'
              : 'Request My Canvassing Packets'
          }}
        </button>

        <div
          *ngIf="petitionError"
          class="error form-error"
        >
          {{ petitionError }}
        </div>

      </form>


      <!-- PACKET SUCCESS -->
      <div
        *ngIf="petitionSubmitted"
        class="success-message"
      >
        <p>
          Your request has been received! We'll mail your canvassing
          packets to you within a few business days. Check your email
          for confirmation.
        </p>

        <button
          type="button"
          (click)="resetPetitionForm()"
        >
          Request More Forms
        </button>
      </div>

    </section>


    <!-- GENERAL VOLUNTEER SIGNUP -->
    <section class="volunteer-section form-section">

      <div class="section-heading">
        <h2>Join the Team</h2>

        <p>
          Want to help in another way? Sign up for canvassing,
          phone banking, events, social media, and more.
        </p>
      </div>


      <form
        #volunteerForm="ngForm"
        (ngSubmit)="onSubmit()"
        *ngIf="!submitted"
        id="volunteer-form"
      >

        <div class="form-grid">

          <!-- NAME -->
          <div class="form-group">
            <label for="vol-name">Full Name</label>

            <input
              id="vol-name"
              type="text"
              placeholder="Full Name"
              required
              [(ngModel)]="volunteer.name"
              name="name"
              #name="ngModel"
              aria-required="true"
              aria-describedby="name-error"
              [disabled]="isSubmitting"
            />

            <div
              *ngIf="name.invalid && name.touched"
              class="error"
              id="name-error"
            >
              Full name is required.
            </div>
          </div>


          <!-- EMAIL -->
          <div class="form-group">
            <label for="vol-email">Email Address</label>

            <input
              id="vol-email"
              type="email"
              placeholder="Email Address"
              required
              [(ngModel)]="volunteer.email"
              name="email"
              #email="ngModel"
              aria-required="true"
              aria-describedby="email-error"
              pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
              [disabled]="isSubmitting"
            />

            <div
              *ngIf="email.invalid && email.touched"
              class="error"
              id="email-error"
            >
              <span *ngIf="email.errors?.['required']">
                Email is required.
              </span>

              <span *ngIf="email.errors?.['pattern']">
                Please enter a valid email address.
              </span>
            </div>
          </div>


          <!-- ZIP -->
          <div class="form-group">
            <label for="vol-zip">Zip Code</label>

            <input
              id="vol-zip"
              type="text"
              placeholder="Zip Code"
              required
              [(ngModel)]="volunteer.zip"
              name="zip"
              #zip="ngModel"
              aria-required="true"
              aria-describedby="zip-error"
              pattern="\d{5}"
              [disabled]="isSubmitting"
            />

            <div
              *ngIf="zip.invalid && zip.touched"
              class="error"
              id="zip-error"
            >
              <span *ngIf="zip.errors?.['required']">
                Zip code is required.
              </span>

              <span *ngIf="zip.errors?.['pattern']">
                Zip code must be 5 digits.
              </span>
            </div>
          </div>


          <!-- ROLE -->
          <div class="form-group">
            <label for="vol-role">How Can You Help?</label>

            <select
              id="vol-role"
              required
              [(ngModel)]="volunteer.role"
              name="role"
              #role="ngModel"
              aria-required="true"
              aria-describedby="role-error"
              [disabled]="isSubmitting"
            >
              <option value="">Select a Role</option>

              <option value="captain">
                Constitutional Captain (Door Knocking)
              </option>

              <option value="canvass">
                Canvassing
              </option>

              <option value="phone">
                Phone Banking
              </option>

              <option value="event">
                Event Hosting
              </option>

              <option value="social">
                Social Media
              </option>
            </select>

            <div
              *ngIf="role.invalid && role.touched"
              class="error"
              id="role-error"
            >
              Please select a role.
            </div>
          </div>

        </div>


        <button
          type="submit"
          class="form-button"
          [disabled]="volunteerForm.invalid || isSubmitting"
          aria-label="Join Lydia's volunteer team"
        >
          {{ isSubmitting ? 'Sending...' : 'Join the Team' }}
        </button>

        <div
          *ngIf="errorMessage"
          class="error form-error"
          id="submit-error"
        >
          {{ errorMessage }}
        </div>

      </form>


      <!-- VOLUNTEER SUCCESS -->
      <div
        *ngIf="submitted"
        class="success-message"
      >
        <p>
          Thank you for volunteering! We'll contact you soon.
        </p>

        <button
          type="button"
          (click)="resetForm()"
        >
          Volunteer Again
        </button>
      </div>

    </section>

  </div>
</section>